import { render, staticRenderFns } from "./Etiquetas.vue?vue&type=template&id=3c9b5178&scoped=true&"
import script from "./etiqueta.ts?vue&type=script&lang=ts&"
export * from "./etiqueta.ts?vue&type=script&lang=ts&"
import style0 from "./etiqueta.scss?vue&type=style&index=0&id=3c9b5178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b5178",
  null
  
)

export default component.exports